// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid,  } from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useEffect, useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import LightboxModal from '../../../../../components/LightboxModal';

import Page from '../../../../../components/Page';
import { doc400 } from '../../../../userImage';
import DocPreview, { LoadingPreview } from './DocPreview';
import DocUploadDropzone from './DocUploadDropzone';
import { FDate } from 'src/constants/defaultValues';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function VerifyCode({doc, isMobile, toast, editable, handleUpdateDoc,handleAddDoc,loading}) {

  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  let [name, setName] = useState('');
  let [rtoNumber, setRtoNumber] = useState('');
  let [issueDate, setIssueDate] = useState('');
  let [soa, setSoa] = useState('');
  let [pin, setPin] = useState('');

  let   [currentFile, setCurrentFile] = useState(null);
  let   [fileOpen, setFileOpen] = useState(false);
  let [cards, setCards] = useState([]);
  let [file, setFile] = useState(null);
  let [fileId, setFileId] = useState(null);


  useEffect(()=>{
    if(doc && doc.id){
        if(doc.name) setName(doc.name);
        if(doc.soa) setSoa(doc.soa);
        if(doc.rto_number) setRtoNumber(doc.rto_number);
        if(doc.issue_date) setIssueDate(doc.issue_date);
        if(doc.pin) setPin(doc.pin);
    }

  },[doc]);


  const handleSubmit = e=>{
    // if(name && soa && rtoNumber && issueDate && pin){
		// if(issueDate=='Invalid Date'){
		// 	toast('warning', 'Please select a valid issue date');
		// 	return;
		// }
      let newCard = {
        // name,
        // soa: soa,
        // rto_number: rtoNumber,
        // issue_date: new Date(issueDate).toISOString().split('T')[0],
        // pin: pin,
      };

      if(fileId){
        newCard.fileId = fileId;
      }

      if(!newCard.fileId && !(doc && doc.id)){
        toast('warning',"Please upload the copy of the card!");
        return;
      }


      if(doc && doc.id){
        handleUpdateDoc(newCard);
      }else{

        handleAddDoc(newCard);
      }

    //   setSoa('');
    //   setName('');
    //   setPin('');
    //   setRtoNumber('');
    //   setIssueDate('');
    // }else{
    //     toast('warning','please fill all the fields!')
    // }

  }

  const handleViewDoc = doc=>{
    setCurrentFile(doc.file);
    setFileOpen(true);
  }

  const stackStyle = {};
  if(isMobile){
    stackStyle.maxHeight = '90vh';
    stackStyle.overflowY = 'auto';
  }

  return (
    <div style={stackStyle}>
      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
          <Paper
            sx={{
              p: 2,
              width: 1,
              position: 'relative',
              border: (theme) => `solid 1px ${theme.palette.grey[500_32]}`,
            }}
          >

        <Grid container spacing={3} sx={{ mb: 2 }}>
          <Grid item xs={2} >
            <Box
                component="img"
                alt="icon"
                src={`/static/icons/NRT-logo-${isLight ? 'light' : 'dark'}.png`}
                loading="lazy"
                decoding="async"
            />
          </Grid>

          <Grid item xs={8} >
             <Typography variant="subtitle1" sx={{ fontSize: 15, textAlign: 'center', marginTop: 1 }}>Competency Card</Typography>
          </Grid>
          <Grid item xs={2} >
            <Box
                component="img"
                alt="icon"
                src={`/static/icons/DT-logo-${isLight ? 'light' : 'dark'}.png`}
                loading="lazy"
                decoding="async"
            />
          </Grid>
        </Grid>

        {/* <Grid container spacing={1} sx={{ mb: 2 }}>
          <Grid item xs={7} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
                {
                  editable?(
                    <TextField value={name} onChange={e=>setName(e.target.value)} id="b-card-name" label="Full Name" variant="outlined" />
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {name}</Typography>
                  )
                }

            </Box>
          </Grid>

          <Grid item xs={5} >
                {
                  editable?(
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker format="dd-MM-yyyy" 
                            label="Issue Date"
                            openTo="day"
                            views={['day','month','year']}
                            value={issueDate}
                            onChange={(newValue) => {
                            setIssueDate(newValue);
                            }}
                        />
                    </LocalizationProvider>
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {FDate(issueDate)}</Typography>
                  )
                }


            </Grid>
        </Grid>
        <Box
            component="form"
            noValidate
            sx={{mb:2}}
            autoComplete="off"
        >
            <Typography variant="subtitle1" sx={{ fontSize: 15, textAlign: 'center', marginTop: 1 }}>Has attained competency in:<br />RIIOHS204A Work Safety at Heights</Typography>
        </Box>
        <Grid container spacing={1} sx={{mb: 2}}>
          <Grid item xs={5} >

                {
                  editable?(
                    <TextField value={soa} onChange={e=>setSoa(e.target.value)} id="b-card-no" label="SOA" variant="standard" size="small" />
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {soa}</Typography>
                  )
                }


          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={6} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
                {
                  editable?(
                    <TextField value={pin} onChange={e=>setPin(e.target.value)} id="b-card-no" label="PIN" variant="standard" size="small" />
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {pin}</Typography>
                  )
                }

            </Box>
          </Grid>
          <Grid item xs={6} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
                {
                  editable?(
                    <TextField value={rtoNumber} onChange={e=>setRtoNumber(e.target.value)} id="b-card-no" label="RTO" variant="standard" size="small" />
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {rtoNumber}</Typography>
                  )
                }

            </Box>
          </Grid>

        </Grid> */}
      </Paper>

      </Stack>

        {
          editable?(
            <Box sx={{ mt: 1 }}>
              <DocUploadDropzone
                label="Upload Card"
                file={file || doc?.file}
                toast={toast}
                onUploaded={(res)=>{ setFileId(res.fileId); setFile(res.url); }}
              />
            </Box>
          ):null
        }
        {
            editable?(
              <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}} onClick={handleSubmit}> {doc?.id ? 'Save changes' : 'Upload'} </LoadingButton>
            ): <DocPreview file={doc.file} />
        }

    </div>
  );
}